/** Valid shift actual-time submission states (Jobs > Shifts actual column). */

export function normalizeActualState(raw) {
  return String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "_");
}

const SUBMITTED_ACTUAL_STATES = new Set([
  "as_scheduled",
  "asscheduled",
  "different",
  "no_show",
  "noshow",
]);

/** True only after user submits As Scheduled, Different, or No Show. */
export function isSubmittedActualState(raw) {
  return SUBMITTED_ACTUAL_STATES.has(normalizeActualState(raw));
}

export function actualStateDisplayLabel(raw) {
  const state = normalizeActualState(raw);
  if (!isSubmittedActualState(state)) return "Not Submitted";
  if (state === "as_scheduled" || state === "asscheduled") return "As Scheduled";
  if (state === "different") return "Different";
  if (state === "no_show" || state === "noshow") return "No Show";
  return "Not Submitted";
}
